import { ChangeDetectionStrategy, Component, Inject, Input, OnInit } from '@angular/core';
import { ItherapyMatch } from '../../interfaces/therapy-match.interface';
import { TherapiesActionCreatorService } from '../../services/therapies-action-creator.service';
import { IclinicalTrials } from '../../interfaces/clinical-trials.interface';
import { TestService } from '@ispm/dashboard/test/services/test.service';

@Component({
  selector: 'gen-therapies-list',
  templateUrl: './therapies-list.component.html',
  styleUrls: ['./therapies-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TherapiesListComponent implements OnInit {
  @Input() drugsList: any;
  @Input() caseStatus: boolean;
  @Input() workflowInputs: any[];
  @Input() activeJobName: any;
  @Input() opinion?: any[];
  private _therapies: ItherapyMatch[];
  @Input()
  set therapies(therapies: any[]) {
    this._therapies = therapies;
    this.getSortedTherapies();
  }
  get therapies() {
    return this._therapies;
  }
  @Input() uncharacterizedTherapies?: any[];
  @Input() notSentForInterpretationTherapies?: any[];
  @Input() trials?: any[];
  @Input() revisionId?: string;
  @Input()
  uncharacterizedTitle?: string;
  @Input()
  uncharacterizedIconClass?: string;
  public emptyMessage: any;

  constructor(private testService: TestService, private therapyAC: TherapiesActionCreatorService) {
    this.emptyMessage = this.testService.testConfiguration.therapyMatchEmptyMessage;
  }

  ngOnInit() {
  }

  getSortedTherapies() {
    const wildTypeTherapies = this.therapies.filter(therapy => this.isWildTypeTherapyMatch(therapy));
    const notWildTypeTherapies = this.therapies.filter(therapy => !this.isWildTypeTherapyMatch(therapy));
    this._therapies = notWildTypeTherapies.concat(wildTypeTherapies);
    return this.therapies;
  }
  getTrials(therapy: ItherapyMatch) {
    const trials = [],
    uniqueSet = new Set();
    therapy.context.forEach((context) => {
      if (!!this.trials
        && ['molecularfinding', 'aberration'].indexOf(context.resourceType.toLowerCase()) > -1
        && this.trials.hasOwnProperty(context.reference)
      ) {
        this.trials[context.reference].forEach((trial: IclinicalTrials) => {
          if (!uniqueSet.has(trial.id)) {
            trials.push(trial);
            uniqueSet.add(trial.id);
          }
        });
      }
    });

    return trials;
  }

  isWildTypeTherapyMatch(therapyMatch: ItherapyMatch): boolean {
    return therapyMatch.alteration == 'Wild Type';
  }
}
